module.exports = __webpack_public_path__ + "img/Bingo_Info_Game4.17d0c74a.png";